export default __webpack_public_path__ + "static/media/icon-search.999bc519.svg";